import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Sale } from 'src/app/models/Sale';
import { ChartDataset, ChartOptions, ChartType } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-graf-ure-po-urah-stolpicni',
  templateUrl: './graf-ure-po-urah-stolpicni.component.html',
  styleUrls: ['./graf-ure-po-urah-stolpicni.component.css']
})
export class GrafUrePoUrahStolpicniComponent implements OnInit, OnChanges {
  @Input() dataList: Array<Sale>;
  @Input() dateItem;
  @Input() saleFilter;
  public titleListUre = [];
  public percentageList = [];
  public valList = [];
  public valCmpList = [];
  
  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: { x: {}, y: {} },
    plugins: {
      //to ne prikaže številk na grafu
      datalabels: {
          display: false,
      },
  },
    elements: {
      point: {
          radius: 2
      }
  },
  };
  public barChartLabels: string[] = []; // for labels
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];
  public barChartColors = [
    {
      backgroundColor: [],
    },
  ];
  public barChartData: ChartDataset[] = [
    { data: [],
      label: 'Odstotek'
    }
  ];
  public colors : any = [];
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit();
  }

  ngOnInit() {
    this.percentageList = [];
    this.getTitleList();
    this.getData();
    for(let i = 0; i < this.percentageList.length; i++) {
      if(this.percentageList[i] < 0) {
        this.barChartColors[0].backgroundColor.push('rgb(220,20,60)');
      } else {
        this.barChartColors[0].backgroundColor.push('rgb(152,251,152)');
      }
    }
    this.barChartLabels = this.titleListUre;
    this.barChartData = [ {data: this.percentageList, label: 'Odstotek'}];
  }

  getTitleList() {
    for(let i = this.dataList.length-1; i >= 0 ; i--) {
      if(this.dataList[i].date === this.dateItem) {
        if(!this.titleListUre.includes(this.dataList[i].title)) {
          this.titleListUre.push(this.dataList[i].title);
        }
      }
    }
  }

  getData() {
    for(let i = this.dataList.length-1; i >= 0 ; i--) {
        if(this.dataList[i].date === this.dateItem) {
          if(this.saleFilter === 'SALEVALUE'){
            if(this.dataList[i].saleValCmp == 0){
              this.percentageList.push(0);
            }else {
              this.percentageList.push(this.roundingToolNoDecimal((this.dataList[i].saleVal / this.dataList[i].saleValCmp) * 100) - 100);
            }
          } else if(this.saleFilter === 'MARGINPERCENT') {
            if(this.dataList[i].marginPrcCmp == 0){
              this.percentageList.push(0);
            } else {
              this.percentageList.push(this.roundingToolNoDecimal((this.dataList[i].marginPrc / this.dataList[i].marginPrcCmp) * 100) - 100);
            }
          } else if (this.saleFilter === 'SALEVALUEWT') {
            if(this.dataList[i].saleValWTCmp == 0){
              this.percentageList.push(0);
            } else {
              this.percentageList.push(this.roundingToolNoDecimal((this.dataList[i].saleValWT / this.dataList[i].saleValWTCmp) * 100) - 100);
            }
          } else if (this.saleFilter === 'QUANTITY') {
            if(this.dataList[i].quantityCmp == 0){
              this.percentageList.push(0);
            } else {
              this.percentageList.push(this.roundingToolNoDecimal((this.dataList[i].quantity / this.dataList[i].quantityCmp) * 100) - 100);
            }
          } else if (this.saleFilter === 'DOCUMENTCOUNT') {
            if(this.dataList[i].docCountCmp == 0){
              this.percentageList.push(0);
            } else {
              this.percentageList.push(this.roundingToolNoDecimal((this.dataList[i].docCount / this.dataList[i].docCountCmp) * 100) - 100);
            }
          } else if (this.saleFilter === 'ITEMCOUNT') {
            if(this.dataList[i].itemCountCmp == 0){
              this.percentageList.push(0);
            } else {
              this.percentageList.push(this.roundingToolNoDecimal((this.dataList[i].itemCount / this.dataList[i].itemCountCmp) * 100) - 100);
            }
          }
        }


    }
  }

  roundingToolNoDecimal(num) {
    return Math.round(num);
  }

}
